import React from 'react';
import clsx from 'clsx';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="flex space-x-2 overflow-x-auto pb-2 rounded-md p-2">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={clsx(
            'px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors border',
            activeCategory === category
              ? 'bg-[#062136] text-white border-[#062136] dark:bg-blue-600 dark:text-white dark:border-blue-600'
              : 'bg-white text-gray-800 border-gray-400 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600 hover:bg-[#062136] hover:text-white hover:border-[#062136] dark:hover:bg-blue-600 dark:hover:text-white dark:hover:border-blue-600'
          )}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
